import { render, staticRenderFns } from "./TabCredential.vue?vue&type=template&id=1044bef4&scoped=true&"
import script from "./TabCredential.vue?vue&type=script&lang=js&"
export * from "./TabCredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1044bef4",
  null
  
)

export default component.exports